import { connect } from 'react-redux';
import { popModal } from '../Modals/redux/basicActions';
const mapStateToProps = (state)=>({});
const mapDispatchToProps = (dispatch)=>({
        close: ()=>dispatch(popModal())
    });
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=CompletionPopup.container.js.map